import { distance2, interpolate } from "@/math/coordinates";
import type { ViewportCoordinate } from "@/model/coordinates";
import { getPointer, otherPointer } from "@/utils/dom/pointer";

import { processZoom } from "./zoom";

interface PinchZoom {
  a: number;
  b: number;
  dist: number;
}

let pinchZoom: PinchZoom | undefined;

export function isPinching(id?: number) {
  return !!pinchZoom && (id === undefined || id === pinchZoom.a || id === pinchZoom.b);
}

export function handlePinchPointerDown(id: number, pos: ViewportCoordinate) {
  const other = otherPointer(id);
  if (other) {
    const dist = distance2(getPointer(other).pos, pos);
    pinchZoom = { a: other, b: id, dist };
  }
}

export function handlePinchPointerMove(id: number) {
  if (pinchZoom && isPinching(id)) {
    const pa = getPointer(pinchZoom.a).pos;
    const pb = getPointer(pinchZoom.b).pos;
    const dist = distance2(pa, pb);
    const f = Math.sqrt(dist / pinchZoom.dist);
    if (Math.abs(f - 1) > 0.01) {
      processZoom(interpolate(0.5, pa, pb), f, "absolute");
    }
  }
}

export function handlePinchPointerUp(id: number) {
  if (isPinching(id)) {
    pinchZoom = undefined;
  }
}
